/**
 * 与浏览器相关的一些方法, 获取浏览器版本
 */

/**
 * 返回 LCID
 */
export function getLanguage() {
  if (typeof window === 'undefined') return ''
  const navigator = window.navigator
  const lang = navigator.language
  return lang.toLowerCase()
}
/**
 *
 * @param {string} language eg. en-US
 * @param {string[]} keys locale file paths
 * @returns
 */
export function isLocaleExists(language, keys) {
  if (!language) return false

  const files = [
    `/${language.replace(/(-\S{2,})/, (match, $1) => $1.toUpperCase())}`,
    `/${language}`,
    `/${language.match(/(\S{2,3})-/)?.[1]}`,
  ]
  return keys.find(v => files.some(vv => v.indexOf(vv) > -1)) || false
}

/**
 * 预加载图片资源
 * @param {string} url
 */
export function preloadImage(url) {
  const img = new Image()
  img.src = url
}

/**
 * 获取浏览器相关参数
 */
const KEY_IOS = 'iOS'
const KEY_ANDROID = 'Android'

export function judgeClient() {
  if (typeof window === 'undefined') {
    return ''
  }
  const u = window.navigator.userAgent
  let client = ''
  if (/(iPhone|iPad|iPod|iOS|Mac)/i.test(u)) {
    client = KEY_IOS
  } else if (/(Android)/i.test(u)) {
    client = KEY_ANDROID
  }
  return client
}

const client = judgeClient()

export const isIOS = client === KEY_IOS
export const isAndroid = client === KEY_ANDROID

const isSafari =
  typeof window !== 'undefined' && /Safari/.test(window.navigator.userAgent)

export function isInApp() {
  if (typeof window === 'undefined') {
    return Promise.resolve({})
  }
  if (isAndroid) {
    const customWindow = window
    return new Promise((resolve, reject) => {
      return resolve(customWindow?.EufyJS)
    })
  }
  if (isIOS) {
    return Promise.resolve(!isSafari)
  }
  return Promise.resolve(false)
}
